import { supabase } from '../lib/supabaseClient';

export interface AccesoCompras {
  comprador: boolean;
  solicitante: boolean;
  adminCompras: boolean;
}

/**
 * Lo que el panel de campo necesita saber de compras: si mostrar las casillas «Comprador» y «Solicitante» en
 * Trabajadores. Solo las ve quien administra compras, porque solo él puede darlas o quitarlas (trigger
 * profiles_guard_comprador, 0272 y 0273): mostrarlas a un admin de campo sería ofrecerle algo que el servidor
 * rechaza. Si la RPC falla, las casillas no aparecen.
 */
export async function miAccesoCompras(): Promise<AccesoCompras> {
  const { data, error } = await supabase.rpc('cmp_yo');
  if (error || !data) return { comprador: false, solicitante: false, adminCompras: false };
  const d = data as { comprador?: boolean; es_solicitante?: boolean; admin_compras?: boolean };
  return { comprador: d.comprador === true, solicitante: d.es_solicitante === true, adminCompras: d.admin_compras === true };
}
